import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'en': {
        'WorkspaceTopbar.MailOptions.Mail': 'Mail',
        'WorkspaceTopbar.MailOptions.Inbox': 'Inbox',
        'WorkspaceTopbar.MailOptions.Compose': 'Compose',

        'WorkspaceMenubar.DashboardOptions.Dashboard': 'Dashboard',
        'WorkspaceMenubar.MarketplaceOptions.Marketplace': 'Marketplace',
        'WorkspaceMenubar.MarketplaceOptions.Dashboard': 'Dashboard',
        'WorkspaceMenubar.MarketplaceOptions.Inventory': 'Inventory',
        'WorkspaceMenubar.MarketplaceOptions.Inventory1': 'Inventory',

        'WorkspaceMenubar.MarketplaceOptions.StockInHand': 'Stock In Hand',
        'WorkspaceMenubar.MarketplaceOptions.Warehouses': 'Warehouses',
        'WorkspaceMenubar.MarketplaceOptions.Transfers': 'Transfers',
        'WorkspaceMenubar.MarketplaceOptions.Returns': 'Returns',
        'WorkspaceMenubar.MarketplaceOptions.Commodities': 'Commodities',
        'WorkspaceMenubar.MarketplaceOptions.AllCommodities': 'All Commodities',
        'WorkspaceMenubar.MarketplaceOptions.AddCommodity': 'Add Commodity',
        'WorkspaceMenubar.MarketplaceOptions.Purchases': 'Purchases',
        'WorkspaceMenubar.MarketplaceOptions.AllPurchases': 'All Purchases',
        'WorkspaceMenubar.MarketplaceOptions.PurchaseOrder': 'Add Purchase Order',
        'WorkspaceMenubar.MarketplaceOptions.Sales': 'Sales',
        'WorkspaceMenubar.MarketplaceOptions.AllSales': 'All Sales',
        'WorkspaceMenubar.MarketplaceOptions.SaleOrder': 'Add Sale Order',
        'WorkspaceMenubar.MarketplaceOptions.Invoices': 'Invoices',
        'WorkspaceMenubar.MarketplaceOptions.AllInvoices': 'All Invoices',
        'WorkspaceMenubar.MarketplaceOptions.NewInvoice': 'Add Invoice',

        'WorkspaceMenubar.MarketplaceOptions.Bills': 'Bills',
        'WorkspaceMenubar.MarketplaceOptions.AllBills': 'All Bills',
        'WorkspaceMenubar.MarketplaceOptions.AddBill': 'Add Bill',

        'WorkspaceMenubar.MarketplaceOptions.Receipts': 'Receipts',

        'WorkspaceMenubar.BuySellOptions["Shop & Supply"]': 'Shop & Supply',
        'WorkspaceMenubar.BuySellOptions.Purchases': 'Purchases',
        'WorkspaceMenubar.BuySellOptions.AllPurchases': 'All Purchases',
        'WorkspaceMenubar.BuySellOptions.Sales': 'Sales',
        'WorkspaceMenubar.BuySellOptions.AllSales': 'All Sales',
        'WorkspaceMenubar.BuySellOptions.Invoices': 'Invoices',

        'WorkspaceMenubar.BuySellOptions.GoodsAndServices': 'Goods & Services',
        'WorkspaceMenubar.BuySellOptions.AllGoodsAndServices': 'All Goods & Services',
        'WorkspaceMenubar.BuySellOptions.NewGoodsAndServices': 'New Goods & Services',

        'WorkspaceMenubar.MarketplaceOptions.Reports': 'Reports',
        'WorkspaceMenubar.MarketplaceOptions.Purchase_Report': 'Purchase Report',
        'WorkspaceMenubar.MarketplaceOptions.Sale_Report': 'Sale Report',
        'WorkspaceMenubar.MarketplaceOptions.Invoice_Report': 'Invoice Report',
        'WorkspaceMenubar.MarketplaceOptions.QualityReport': 'Quality Report',
        'WorkspaceMenubar.MarketplaceOptions.TraceReport': 'Trace Report',


        'WorkspaceMenubar.MarketplaceOptions.Assignment': 'Assignment',
        'WorkspaceMenubar.MarketplaceOptions.Assignment_Report': 'Assignment Report',
        'WorkspaceMenubar.MarketplaceOptions.Sale_Assignment': 'Sale Assignment',



        'WorkspaceMenubar.GrowersOptions.Growers': 'Partners',
        'WorkspaceMenubar.GrowersOptions.ViewGrowers': 'Partners',
        'WorkspaceMenubar.GrowersOptions.AddGrower': 'Add Partners',

        'WorkspaceMenubar.GrowersOptions.Members': 'Members',
        'WorkspaceMenubar.GrowersOptions.ViewMembers': 'Members',

        'WorkspaceMenubar.GrowersOptions.ViewSellers': 'View Sellers',
        'WorkspaceMenubar.GrowersOptions.AddSeller': 'Add Seller',

        'WorkspaceMenubar.GrowersOptions.ViewBuyers': 'View Buyers',
        'WorkspaceMenubar.GrowersOptions.AddBuyer': 'Add Buyer',

        'WorkspaceMenubar.GrowersOptions.GoodsAndServices': 'Goods & Services',
        'WorkspaceMenubar.GrowersOptions.AddGoodsAndServices': 'Add Goods & Services',

        'WorkspaceMenubar.GrowersOptions.Contractbook': 'Contract Book',

        'WorkspaceMenubar.OffersOptions.Offers': 'Offers',
        'WorkspaceMenubar.OffersOptions.ShowOffers': 'Show Offers',
        'WorkspaceMenubar.OffersOptions.MyOffers': 'My Offers',
        'WorkspaceMenubar.OffersOptions.PostNewOffer': 'Post New Offer',

        'WorkspaceMenubar.TradesOptions.Trades': 'Trades',
        'WorkspaceMenubar.TradesOptions.MyTrades': 'My Trades',
        'WorkspaceMenubar.TradesOptions.Report': 'Trade Report',

        'WorkspaceMenubar.ReportOptions.Report': 'Report',
        'WorkspaceMenubar.ReportOptions.QualityReport': 'Quality Report',

        'WorkspaceMenubar.MarketplaceContractOptions.Contractbook': 'Contract Book',
        'WorkspaceMenubar.MarketplaceContractOptions.Contracts': 'Contracts',
        'WorkspaceMenubar.MarketplaceContractOptions.AllContracts': 'All Contracts',
        'WorkspaceMenubar.MarketplaceContractOptions.NewContract': 'Add Contract',
        'WorkspaceMenubar.MarketplaceOptions.Challans': 'Challans',
        'WorkspaceMenubar.MarketplaceOptions.NewChallans': 'Challans',
        'WorkspaceMenubar.MarketplaceOptions.DeliveryNotes': 'Delivery Notes',

        'WorkspaceMenubar.PriceDiscoveryOptions.PriceDiscovery': 'Price Discovery',
        'WorkspaceMenubar.PriceDiscoveryOptions.PriceCharts': 'Price Charts',
        'WorkspaceMenubar.PriceDiscoveryOptions.HistoricalInfo': 'Historical Info',
        'WorkspaceMenubar.PriceDiscoveryOptions.TradingView': 'Trading View',

        'WorkspaceMenubar.OrgAdminOptions.OrgAdmin': 'Org Admin',
        'WorkspaceMenubar.OrgAdminOptions.Profile': 'Profile',
        'WorkspaceMenubar.OrgAdminOptions.Members': 'Staff',
        'WorkspaceMenubar.OrgAdminOptions.Settings': 'Settings',
        'WorkspaceMenubar.OrgAdminOptions.Taxes': 'Taxes',
        'WorkspaceMenubar.OrgAdminOptions["Subscription Plan"]': 'Subscription Plan',
        'WorkspaceMenubar.OrgAdminOptions.Invoice': 'Invoice',
        'WorkspaceMenubar.OrgAdminOptions.MembershipPlan': 'Membership Plan',
        'WorkspaceMenubar.OrgAdminOptions.BankAccounts': 'Bank Accounts',
        'WorkspaceMenubar.OrgAdminOptions.Wallet': 'Wallet',
        'WorkspaceMenubar.OrgAdminOptions.ApiIntegrations': 'API Integrations',

        'WorkspaceMenubar.OrgAdminOptions.PartnershipType': 'Partnership Type',

        'WorkspaceMenubar.MyAccountOptions.MyAccount': 'My Account',
        'WorkspaceMenubar.MyAccountOptions.AccountInfo': 'Account Info',

        'Dashboard.Overview': 'Overview',

        /** EXPRESS OPTIONS **/
        'WorkspaceMenubar.ExpressOptions.Shop&Supply': 'Shop & Supply',
        'WorkspaceMenubar.ExpressOptions.Dashboard': 'Dashboard',
        'WorkspaceMenubar.ExpressOptions.Purchases': 'Purchases',
        'WorkspaceMenubar.ExpressOptions.AllPO': 'Purchase Orders',
        'WorkspaceMenubar.ExpressOptions.AddPO': 'Add Purchase Order',
        'WorkspaceMenubar.ExpressOptions.GoodsAndServices': 'Goods & Services',
        'WorkspaceMenubar.ExpressOptions.AddGoodsAndServices': 'Add Goods & Services',
        'WorkspaceMenubar.ExpressOptions.AllSellers': 'All Sellers',
        'WorkspaceMenubar.ExpressOptions.AddSeller': 'Add Seller',
        'WorkspaceMenubar.ExpressOptions.Sales': 'Sales',
        'WorkspaceMenubar.ExpressOptions.AllBuyers': 'All Buyers',
        'WorkspaceMenubar.ExpressOptions.AddBuyer': 'Add Buyer',
        'WorkspaceMenubar.ExpressOptions.Invoices': 'Invoices',
        'WorkspaceMenubar.ExpressOptions.AllInvoices': 'All Invoices',
        'WorkspaceMenubar.ExpressOptions.NewInvoice': 'Add Invoice',
        'WorkspaceMenubar.ExpressOptions.Contractbook': 'Contract Book',
        'WorkspaceMenubar.ExpressOptions.Contracts': 'Contracts',
        'WorkspaceMenubar.ExpressOptions.AllContracts': 'All Contracts',
        'WorkspaceMenubar.ExpressOptions.NewContract': 'Add Contract',
        'WorkspaceMenubar.ExpressOptions.Challans': 'Challans',
        'WorkspaceMenubar.ExpressOptions.NewChallan': 'New Challan',
    },
    'hi': {
        'WorkspaceTopbar.MailOptions.Mail': 'डाक',
        'WorkspaceTopbar.MailOptions.Inbox': 'इनबॉक्स',
        'WorkspaceTopbar.MailOptions.Compose': 'लिखें',

        'WorkspaceMenubar.DashboardOptions.Dashboard': 'डैशबोर्ड',
        'WorkspaceMenubar.MarketplaceOptions.Marketplace': 'बाजार',
        'WorkspaceMenubar.MarketplaceOptions.Dashboard': 'डैशबोर्ड',
        'WorkspaceMenubar.MarketplaceOptions.Inventory': 'सूची',
        'WorkspaceMenubar.MarketplaceOptions.Inventory1': 'सूची1',

        'WorkspaceMenubar.MarketplaceOptions.StockInHand': 'मौजूद',
        'WorkspaceMenubar.MarketplaceOptions.Warehouses': 'गोदामों',
        'WorkspaceMenubar.MarketplaceOptions.Transfers': 'स्थानांतरण',
        'WorkspaceMenubar.MarketplaceOptions.Returns': 'रिटर्न',
        'WorkspaceMenubar.MarketplaceOptions.Commodities': 'वस्तु',
        'WorkspaceMenubar.MarketplaceOptions.AllCommodities': 'सभी वस्तुओं',
        'WorkspaceMenubar.MarketplaceOptions.AddCommodity': 'वस्तु जोडें',
        'WorkspaceMenubar.MarketplaceOptions.Purchases': 'खरीद',
        'WorkspaceMenubar.MarketplaceOptions.AllPurchases': 'सभी खरीद',
        'WorkspaceMenubar.MarketplaceOptions.PurchaseOrder': 'खरीद ऑर्डर जोडें',
        'WorkspaceMenubar.MarketplaceOptions.Sales': 'बिक्री',
        'WorkspaceMenubar.MarketplaceOptions.AllSales': 'सभी बिक्री',
        'WorkspaceMenubar.MarketplaceOptions.SaleOrder': 'विक्रय ऑर्डर जोडें',
        'WorkspaceMenubar.MarketplaceOptions.Invoices': 'चालान',
        'WorkspaceMenubar.MarketplaceOptions.AllInvoices': 'सभी चालान',
        'WorkspaceMenubar.MarketplaceOptions.NewInvoice': 'चालान जोडें',
        'WorkspaceMenubar.MarketplaceOptions.Challans': 'चालान',
        'WorkspaceMenubar.MarketplaceOptions.Challan': 'चालान',

        'WorkspaceMenubar.BuySellOptions["Shop & Supply"]': 'दुकान और आपूर्ति',
        'WorkspaceMenubar.BuySellOptions.Purchases': 'खरीद',
        'WorkspaceMenubar.BuySellOptions.AllPurchases': 'सभी खरीद',
        'WorkspaceMenubar.BuySellOptions.Sales': 'बिक्री',
        'WorkspaceMenubar.BuySellOptions.AllSales': 'सभी बिक्री',
        'WorkspaceMenubar.BuySellOptions.Invoices': 'चालान',

        'WorkspaceMenubar.BuySellOptions.GoodsAndServices': 'वस्तुओं और सेवाओं',
        'WorkspaceMenubar.BuySellOptions.AllGoodsAndServices': 'सभी वस्तुओं और सेवाओं',
        'WorkspaceMenubar.BuySellOptions.NewGoodsAndServices': 'वस्तुओं और सेवाओं जोडें',

        'WorkspaceMenubar.MarketplaceOptions.Reports': 'विवरणी',
        'WorkspaceMenubar.MarketplaceOptions.Purchase_Report': 'खरीद विवरणी',
        'WorkspaceMenubar.MarketplaceOptions.Sale_Report': 'बिक्री विवरणी',
        'WorkspaceMenubar.MarketplaceOptions.Invoice_Report': 'चालान विवरणी',

        'WorkspaceMenubar.GrowersOptions.Growers': 'उत्पादकों',
        'WorkspaceMenubar.GrowersOptions.ViewGrowers': 'उत्पादकों को देखें',
        'WorkspaceMenubar.GrowersOptions.AddGrower': 'उत्पादक जोड़ें',

        'WorkspaceMenubar.GrowersOptions.ViewSellers': 'विक्रेताओं को देखें',
        'WorkspaceMenubar.GrowersOptions.AddSeller': 'विक्रेता जोड़ें',

        'WorkspaceMenubar.GrowersOptions.ViewBuyers': 'खरीददारों को देखें',
        'WorkspaceMenubar.GrowersOptions.AddBuyer': 'खरीददार जोड़ें',

        'WorkspaceMenubar.GrowersOptions.GoodsAndServices': 'वस्तुओं और सेवाओं',
        'WorkspaceMenubar.GrowersOptions.AddGoodsAndServices': 'वस्तुओं और सेवाओं जोड़ें',

        'WorkspaceMenubar.GrowersOptions.Settlement': 'समझौता',

        'WorkspaceMenubar.OffersOptions.Offers': 'प्रस्तावों',
        'WorkspaceMenubar.OffersOptions.ShowOffers': 'प्रस्ताव दिखाएं',
        'WorkspaceMenubar.OffersOptions.MyOffers': 'मेरे प्रस्ताव',
        'WorkspaceMenubar.OffersOptions.PostNewOffer': 'नया प्रस्ताव',

        'WorkspaceMenubar.TradesOptions.Trades': 'व्यापार',
        'WorkspaceMenubar.TradesOptions.MyTrades': 'मेरे व्यापार',
        'WorkspaceMenubar.TradesOptions.Report': 'व्यापार रिपोर्ट',

        'WorkspaceMenubar.PriceDiscoveryOptions.PriceDiscovery': ' मूल्य डिस्कवरी',
        'WorkspaceMenubar.PriceDiscoveryOptions.PriceCharts': 'मूल्य चार्ट',
        'WorkspaceMenubar.PriceDiscoveryOptions.HistoricalInfo': 'ऐतिहासिक जानकारी',
        'WorkspaceMenubar.PriceDiscoveryOptions.TradingView': 'व्यापार राय',

        'WorkspaceMenubar.OrgAdminOptions.OrgAdmin': 'संगठन व्यवस्थापक',
        'WorkspaceMenubar.OrgAdminOptions.Profile': 'प्रोफ़ाइल',
        'WorkspaceMenubar.OrgAdminOptions.Members': 'सदस्यों',
        'WorkspaceMenubar.OrgAdminOptions.Settings': 'सेटिंग्स',
        'WorkspaceMenubar.OrgAdminOptions.Taxes': 'करों',
        'WorkspaceMenubar.OrgAdminOptions["Subscription Plan"]': 'सदस्यता योजना',
        'WorkspaceMenubar.OrgAdminOptions.Invoice': 'चालान',
        'WorkspaceMenubar.OrgAdminOptions.MembershipPlan': 'सदस्यता योजना',
        'WorkspaceMenubar.OrgAdminOptions.BankAccounts': 'बैंक  हिसाब',
        'WorkspaceMenubar.OrgAdminOptions.Wallet': 'पर्स',
        'WorkspaceMenubar.OrgAdminOptions.ApiIntegrations': 'API एकीकरण',

        'WorkspaceMenubar.OrgAdminOptions.PartnershipType': 'भागीदारों प्रकार',

        'WorkspaceMenubar.MyAccountOptions.MyAccount': 'मेरा अकाउंट',
        'WorkspaceMenubar.MyAccountOptions.AccountInfo': 'अकाउंट जानकारी',

        'Dashboard.Overview': 'अवलोकन',


        /** EXPRESS OPTIONS **/
        'WorkspaceMenubar.ExpressOptions.Shop&Supply': 'दुकान और आपूर्ति',
        'WorkspaceMenubar.ExpressOptions.Dashboard': 'अवलोकन',
        'WorkspaceMenubar.ExpressOptions.Purchases': 'खरीद',
        'WorkspaceMenubar.ExpressOptions.GoodsAndServices': 'वस्तुओं और सेवाओं',
        'WorkspaceMenubar.ExpressOptions.AddGoodsAndServices': 'वस्तुओं और सेवाओं जोड़ें',
        'WorkspaceMenubar.ExpressOptions.AllSellers': 'वसभी विक्रेता',
        'WorkspaceMenubar.ExpressOptions.AddSeller': 'विक्रेता जोड़ें',
        'WorkspaceMenubar.ExpressOptions.Sales': 'बिक्री',
        'WorkspaceMenubar.ExpressOptions.AllBuyers': 'सभी खरीदार',
        'WorkspaceMenubar.ExpressOptions.AddBuyer': 'खरीददार जोड़ें',
        'WorkspaceMenubar.ExpressOptions.Invoices': 'चालान',
        'WorkspaceMenubar.ExpressOptions.AllInvoices': 'सभी चालान',
        'WorkspaceMenubar.ExpressOptions.NewInvoice': 'चालान जोडें',
        'WorkspaceMenubar.ExpressOptions.Contractbook': 'कॉन्ट्रैक्टबुक',
        'WorkspaceMenubar.ExpressOptions.Contracts': 'अनुबंध',
        'WorkspaceMenubar.ExpressOptions.AllContracts': 'सभी अनुबंध',
        'WorkspaceMenubar.ExpressOptions.NewContract': 'अनुबंध जोडें',
        'WorkspaceMenubar.ExpressOptions.Challans': 'चालान',
        'WorkspaceMenubar.ExpressOptions.NewChallan': 'नई चालान',
    }
};

const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages: messages // set locale messages
});

export default i18n;
